import './focus.css';
import './spatial_navigation';

import React, { Component } from 'react';
import { ThirdPartyEpgHelper, TPA_WAS_FIRED } from '../../AAFPlayer/helpers/ThirdPartyEpgHelper';
import DeviceStorage from '../DeviceStorage/DeviceStorage';
import LayersControl from '../../utils/LayersControl';

class Focus extends Component {
  componentDidMount() {
    // Initialize
    window.SpatialNavigation.init();

    const areas=[
      {
        name: 'landing-tv-everywhere',
        config: {
          selector: '#landing-tv-everywhere .focusable',
          restrict: 'self-only'
        }
      },
      {
        name:'landing-page_markers',
        config:{
          selector: '.landing-page_markers .marker.focusable',
          /*defaultElement: '.active',*/
          enterTo: 'last-focused',
          leaveFor:{down:'@landing-page_buttons'},
          restrict: 'self-only'
        }
      },{
        name: 'landing-page_buttons',
        config: {
          selector: '.landing-page_buttons .btn',
          enterTo: 'last-focused',
          leaveFor:{up:'@landing-page_markers'},
          restrict: 'self-only'
        }
      },
      {
        name:'header-cintillo',
        config:{
          selector: '.header-cintillo .focusable',
          /*defaultElement: '.active',*/
          enterTo: 'default-element',
          leaveFor:{down:'.header-top .focusable'},
        }
      },{
        name:'header-top',
        config:{
          selector: '.header-top .focusable',
          defaultElement: '.active',
          enterTo: 'default-element',
          leaveFor:{down:'.header-down .focusable .active'},
        }
      },
      {
        name:'nav_down',
        config:{
          selector: '.header-down .focusable',
          defaultElement: '.active',

          leaveFor:{down:'.scroller-container .focusable:first-child'},
          enterTo: 'default-element',
        }
      },
      {
        name:'ribbon-categories',
        config:{
          selector:'.ribbon-categories .focusable',
          defaultElement: '.selected',
          enterTo: 'default-element',
        }
      },
      {
        name:'keyboard',
        config:{
          selector:'.keyboard .notModal .focusable',
          leaveFor:{right:'.results .focusable'},
        }
      },
      {
        name:'keyboard_pin',
        config:{
          selector:'.keyboard .modal .focusable',
          leaveFor:{right:'.right .focusable'},
        }
      },
      {
        name:'main_container',
        config:{
          selector: '.container .focusable',
          defaultElement: '.elementopredeterminado',
          /*enterTo: 'default-element',*/
          leaveFor:{up:'.header-down .focusable',right:':focus'},
        }
      },
      {
        name:'player_controls',
        config:{
          selector: '.player-ui-controls .focusable',
        }
      },
      {
        name:'n_player_controls',
        config:{
          selector: '.player-controls-container .whenfocusable',
        }
      },
      {
        name:'n_player_controls_colored_bar_miniepg_zone',
        config:{
          selector: '.miniepg-colored-bar-zone .whenfocusable',
        }
      },
      {
        name:'n_player_controls_colored_bar_playercontrols_zone',
        config:{
          selector: '.playercontrols-colored-bar-zone .whenfocusable',
        }
      },
      {
        name:'n_player_controls_skip_intro',
        config:{
          selector: '.player-controls-skipintro-container .whenfocusable',
        }
      },
      {
        name:'focusable',
        config:{
          selector: '.player-controls-container .focusable',
        }
      },
      {
        name:'mini-epg',
        config:{
          selector: '.player-ui-epg .focusable',
        }
      },

      {
        name:'persistent-mini-epg',
        config:{
          selector: '.mini-main-container .focusable',
          restrict: 'self-only',
        }
      },

      {
        name: 'epg_cover_flow',
        config: {
          selector: '.epg-cover-flow .focusable',
          restrict: 'self-only',
        }
      },

      {
        name: 'colors',
        config: {
          selector: '.color-codes .focusable'
        }
      },

      {
        name:'epg',
        config:{
          selector: '.full-epg .epg-events-container .focusable',
          restrict: 'self-only',
        }
      },

      {
        name:'fin_player',
        config:{
          selector: '.end-player .focusable',
          defaultElement: '.focusable-default',
          enterTo: 'default-element',
        }
      },

      {
        name:'modal-area-top',
        config:{
          selector: '.modal-overlay .vcard-seasons .focusable',

          /* defaultElement: '.elementopredeterminado',
           enterTo: 'default-element',  */
          leaveFor:{down:'.modal-overlay  .ribbon-container .focusable'},



          restrict: 'self-only',
        }
      },

      {
        name:'modal-area',
        config:{
          selector: '.modal-overlay .focusable',
          defaultElement: '.modal-default-item',
          /* defaultElement: '.elementopredeterminado',
           enterTo: 'default-element',
           leaveFor:{up:'.header-down .focusable'},

           */

          restrict: 'self-only',
        }
      },

      {
        name:'epg-channels',
        config:{
          selector: '.channels-wrapper .focusable',
        }
      },
      {
        name:'notification-shortcut',
        config:{
          selector: '.app-notification-section-message .focusable',
          restrict: 'self-only',
        }
      },

    ];

    areas.map(x=>{

      window.SpatialNavigation.add(x.name,x.config);
    });

    // Define navigable elements (anchors and elements with "focusable" class).
    /*window.SpatialNavigation.add({
      id: settings.id,
      main: settings.main,
      selector: settings.selector,

      // We can define our own filter function.
      navigableFilter: function (elem) {
        return elem.className.indexOf(settings.filterout) < 0;
      }
    }); */




    const enterUpHandler = function (e) {
      
      // Verificar por el clic, si viene desde netflix
      if(ThirdPartyEpgHelper.getAAFTPAState() === TPA_WAS_FIRED) {
        // ThirdPartyEpgHelper.setAAFTPAState(null); 
        e.preventDefault && e.preventDefault();
        e.stopPropagation && e.stopPropagation();

        // Lanzar TV en vivo
        // ThirdPartyEpgHelper.fireTV();

        return;
      }

      console.log('Focus component, focus container send clic to> ', e.target);
      e.target.click();
    };
    const enterDownHandler = function (e) {
      e.preventDefault();

      //console.info(' [PS4] FOCUS DEBUG MemInfo ==============');
      //console.info(window.WM_devSettings.memoryInfo);
    };

    window.addEventListener('sn:enter-up', enterUpHandler);
    window.addEventListener('sn:enter-down', enterDownHandler);
    window.addEventListener('visibilitychange', (e) => { 
      if( document.visibilityState === "visible") {
        setTimeout(() => {  
          ThirdPartyEpgHelper.setAAFTPAState(null); 
        }, 0)
        if(DeviceStorage.getItem("fireTPAOnReload")) {
          DeviceStorage.unsetItem("fireTPAOnReload");
          LayersControl.showUX();
        }
      }
    })

    // Make the *currently existing* navigable elements focusable.
    window.SpatialNavigation.makeFocusable();

    // Focus the first navigable element.
    window.SpatialNavigation.focus();
  }

  render() {
    console.log("render focus");
    return (
      <div className="focus-container" />

    )
  }
}

export default Focus;



// WEBPACK FOOTER //
// ./src/components/Focus/index.jsx